export default __webpack_public_path__ + "15edb957c4c7ea348e3d60aceebc2364.png";